











import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		isVisible: Boolean,
	},
	setup() {
		return {};
	},
});
